import React, { useEffect, useState } from "react";
import styles from "./AdminImage.module.css";
import Loader from "../../../../Loader";
import { Link, useNavigate } from "react-router-dom";
import { AxiosInstance } from "../../../../../../axios";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { ImageUrlPrefix } from "../../../../../../labels";
import { useDispatch } from "react-redux";

function GridImageAdminInfo() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [existFolderData, setExistFolderData] = useState([]);

  // ------------------Retrieve user type from sessionStorage
  const userJSON = sessionStorage.getItem("userDetails");
  const user = userJSON ? JSON.parse(userJSON) : null;
  const user_type = user?.user_type || null;
  const hasGalleryAccess = user?.menu_list?.some((id) => id >= 49 && id <= 61);

  // const handleMapNewFolderNames = async () => {
  useEffect(() => {
    setIsLoading(true);

    AxiosInstance.post("/api/gallery/list", folderPayloadImage)
      .then((res) => {
        const seenFolders = new Set();
        const listObject = res.data?.data
          ?.filter((item) => {
            if (seenFolders.has(item.folder_name)) {
              return false;
            }
            seenFolders.add(item.folder_name);
            return true;
          })
          .map((item) => ({
            folderName: item.folder_name,
            image: item.gallery_path,
            displayOption: item.display_option,
            id: item.folder_id,
          }));
        // Sort the list to show `display_option == 0` at the end
        const sortedList = listObject.sort(
          (a, b) => b.displayOption - a.displayOption
        );

        setExistFolderData(sortedList);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const folderPayloadImage = {
    img_type: 1,
    is_admin: user_type === 1 ? 1 : 0,
    page: "",
    page_size: "",
    folder_id: "",
  };

  const handleFolderClick = (id) => {
    navigate(`/ViewImages/${id}`);
  };

  const handleSubmit = () => {
    navigate(`/AddImageAdmin`);
  };
  const handleFolderSubmit = () => {
    navigate(`/AddFolderAdmin/1`);
  };

  const handleBackHome = () => {
    navigate(`/`);
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className={`${styles.GalleryInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">Images</h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul class="List-Button">
            {/* <li className="ListBtnItems">
              <Link
                onClick={handleBackHome}
                to="javascript:void(0)"
                className="secondaryButton"
              >
                Back to Home
              </Link>
            </li> */}
            {(user_type === 1 || hasGalleryAccess) && (
              <>
                <li className="ListBtnItems">
                  <Link
                    to="javascript:void(0)"
                    onClick={handleFolderSubmit}
                    className="primaryButton text-center"
                  >
                    Add New Folder
                  </Link>
                </li>

                <li className="ListBtnItems">
                  <Link
                    to="javascript:void(0)"
                    onClick={handleSubmit}
                    className="primaryButton text-center"
                  >
                    Add New Image
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
        {existFolderData.length > 0 ? (
          <>
            <div className={`${styles.gridContainer} row pt-2`}>
              {existFolderData.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="col-md-3 col-12 mb-4"
                    onClick={() => handleFolderClick(item.id)} // Add click handler
                    style={{ cursor: "pointer" }} // Add cursor pointer
                  >
                    <div
                      className={`${styles.card} card text-center`}
                      // style={{
                      //   filter: item.displayOption === 0 ? "blur(3px)" : "none",
                      // }}
                    >
                      <div className={styles.imageContainer}>
                        <LazyLoadImage
                          src={`${ImageUrlPrefix}/${item.image}`}
                          alt={item.folderName || "Image"}
                          className={`${styles.thumbnail} card-img-top`}
                          // effect="blur"
                          style={{
                            filter:
                              `${item.image}` ==
                              "uploads/signature/default_image.jpg"
                                ? "blur(2px)"
                                : "",
                          }}
                        />

                        <button className={`${styles.viewButton} btn`}>
                          View Images
                        </button>
                      </div>

                      <div
                        className={`${styles.folderName} card-body`}
                        title={item.folderName || "Untitled"}
                      >
                        {item.folderName || "Untitle"}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        ) : (
          <>
            <p style={{ textAlign: "center" }}>No Records to display</p>
          </>
        )}
      </div>
    </div>
  );
}

export default GridImageAdminInfo;
